module.exports = __webpack_public_path__ + "static/media/pic5.13bd7f3d.jpg";